<template>
  <footer>
    <preloader></preloader>
    <cookie-confirm></cookie-confirm>
    <div class="container">
      <div class="home--footer-one-row">
        <div class="footer-left">
          <div class="logo">
            <a href="/"><img src="../../assets/img/header-logo.png" /> Enroller</a>
          </div>
          <div class="find-time mrg-t-5">
            <div>
              Enroller - Время найдется
            </div>
          </div>
          <div class="mrg-t-25 mb-20 bank-systems">
            <img src="../../assets/img/pay-system.png">
          </div>
        </div>
        <div class="footer-center">
          <span><b>Правовая информация:</b></span>
          <br>
          <div class="doc-links mrg-t-15 mrg-b-25">
            <div style="text-decoration: underline;">
              <a class="text-white" href="https://enroller.ru/user-agreement.html" target="_blank">
                &#8226; Пользовательское соглашение
              </a>
            </div>
            <div style="text-decoration: underline;" class="mt-2">
              <a class="text-white" href="https://enroller.ru/rules-online-enroll.html" target="_blank">
                &#8226; Правила онлайн-записи
              </a>
            </div>
            <div style="text-decoration: underline;" class="mt-2">
              <a class="text-white" href="https://enroller.ru/privacy-policy.html" target="_blank">
                &#8226; Политика обработки персональных данных
              </a>
            </div>
            <div style="text-decoration: underline;" class="mt-2">
              <a class="text-white" href="https://enroller.ru/sms-price.html" target="_blank">
                &#8226; Тарифы поддержки системы рассылки СМС-сообщений
              </a>
            </div>
            <div style="text-decoration: underline;" class="mt-2 mb-20">
              <a class="text-white" href="https://enroller.ru/payment-rules.html" target="_blank">
                &#8226; Правила оплаты банковской картой
              </a>
            </div>
          </div>
        </div>
        <div class="footer-right">
          <p>По всем вопросам:</p>
          <div>
            info@enroller.ru
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <hr class="footer-hr" />
        </div>
      </div>
      <div class="row">
        <div class="col-12 footer-copyright">
          © Enroller. 2018 - {{date.getFullYear()}}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import SocialIcons from "./SocialIcons";
import Preloader from "../Preloader";
import CookieConfirm from "./CookieConfirm";

export default {
  name: "MainFooter",
  components: {
    CookieConfirm,
    Preloader,
    SocialIcons
  },
  data() {
    return {
      slidesData: [],
      date: new Date()
    };
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
//header {
//  color: white;
//  height: 60px;
//  background-color: #3c4959;
//}
//.home--header-container {
//  display: flex;
//  flex-wrap: nowrap;
//  justify-content: space-between;
//}
.home--footer-one-row{
  .footer-left{

    .find-time{
      color: #fff;
    }
    .logo{
      height: 45px;

      a{
        line-height: 45px;

        img{
          vertical-align: middle;
          width: 45px;
        }
      }
    }
  }
}
.home--logo {
  font-size: 20px;
  font-weight: 700;
  line-height: 60px;
  color: white;

  a {
    color: white;
    text-decoration: none;
    line-height: 55px;

    img {
      width: 50px;
      vertical-align: middle;
    }
  }
}
.bank-systems{
  img{
    width: 200px;
  }
}

</style>
